import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";

const CoverWrapper = styled.div.attrs(
  ({ align, minHeight, minHeightUnit }) => ({
    align: align,
    minHeight: minHeight || 50,
    minHeightUnit: minHeightUnit || "vh",
  })
)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: ${({ align }) => (align === "full" ? "1570px" : "1180")};
  min-height: ${({ minHeight, minHeightUnit }) =>
    `${minHeight}${minHeightUnit}`};
  margin: 0 auto;
`;

const CoverOverlay = styled.div.attrs(({ $dimRatio, $backgroundColor }) => ({
  $opacity: $dimRatio ? $dimRatio / 100 : 0,
  $backgroundColor: $backgroundColor || "#000",
}))`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  opacity: ${({ $opacity }) => $opacity};
`;

const Img = styled(ImageLibpixel).attrs(({ $minHeight, $minHeightUnit }) => ({
  $minHeight: $minHeight || 50,
  $minHeightUnit: $minHeightUnit || "vh",
}))`
  width: 100%;
  max-width: 1920px;
  height: ${({ $minHeight, $minHeightUnit }) =>
    `${$minHeight}${$minHeightUnit}`};
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;
const InnerBlock = styled.div.attrs(({ minHeight, minHeightUnit }) => ({
  minHeight: minHeight || 50,
  minHeightUnit: minHeightUnit || "vh",
}))`
  position: relative;
  z-index: 5;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  flex-basis: ${({ minHeight, minHeightUnit }) =>
    `${minHeight}${minHeightUnit}`};
  flex-grow: 1;
  flex-shrink: 1;
  min-height: ${({ minHeight, minHeightUnit }) =>
    `${minHeight}${minHeightUnit}`};
`;

const Cover = ({
  imgSrc,
  minHeight,
  minHeightUnit,
  align,
  dimRatio,
  overlayColor,
  children,
}) => {
  return (
    <>
      <CoverWrapper
        minHeight={minHeight}
        minHeightUnit={minHeightUnit}
        align={align}
        className="cover-bread"
      >
        <Img
          src={imgSrc}
          alt="cover-bilde"
          $minHeight={minHeight}
          $minHeightUnit={minHeightUnit}
          width={1920}
          mode="fit"
        />
        <CoverOverlay $backgroundColor={overlayColor} $dimRatio={dimRatio} />
        <InnerBlock
          className="cover-inner-bread"
          minHeight={minHeight}
          minHeightUnit={minHeightUnit}
        >
          {children}
        </InnerBlock>
      </CoverWrapper>
    </>
  );
};

Cover.propTypes = {
  imgSrc: PropTypes.string,
  minHeight: PropTypes.number,
  minHeightUnit: PropTypes.string,
  align: PropTypes.string,
  children: PropTypes.node,
  dimRatio: PropTypes.number,
  overlayColor: PropTypes.string,
};

Cover.defaultProps = {
  imgSrc: undefined,
};

export default Cover;
